import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=bd2d3b38&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2d3b38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd2d3b38')) {
      api.createRecord('bd2d3b38', component.options)
    } else {
      api.reload('bd2d3b38', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=bd2d3b38&scoped=true&", function () {
      api.rerender('bd2d3b38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tv6drpUt1QR7/JS/comp/Voucher-Unit.vue"
export default component.exports